import { OPEN_SECTIONS_INDEX, CLOSE_SECTIONS_INDEX } from 'actions/SectionsIndexActions'

function initialState() {
  return {
    isOpen: false,
  }
}

export default function sectionsIndex(state = initialState(), action) {
  switch (action.type) {
    case OPEN_SECTIONS_INDEX:
      return { ...state, ...action.payload }
    case CLOSE_SECTIONS_INDEX:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
